import React from 'react'
import { Link } from 'react-router-dom'
import SurveyListSidebar from '../../../component/layout/MainSidebar'
import SurveyListHeader from '../../../component/layout/MainHeader'

export default function ROIAnalytics() {
    return (
        <div className='d-flex flex-column main-outer-wrapper'>
            <SurveyListHeader />
            <div className="flex-grow-1 d-flex survey-main-wrapper">
                <SurveyListSidebar />
                <div className="flex-grow-1 dashboard-page-outer">
                    <div className="custom-breadcrumb">
                        {/* breadcrumbs here */}
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/admin/roi" className="home-item" title="Home">Home</Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    <strong>Analytics</strong>
                                </li>
                            </ol>
                        </nav>
                        {/* breadcrumbs ends here */}
                    </div>
                    <div className='dashboard-page-wrap'>
                        <div className="tablePage bg-white overflow-custom">
                            <h3 className='coming-soon text-center mb-0'>Coming Soon</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}
